import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Label } from 'reactstrap';
import Checkbox from '../components/checkbox/checkbox';
import { CheckBoxStyle } from '../components/checkbox/checkbox.css';
import { statusGroups } from '../constants/status-groups';

const StatusGroupParentCheckbox = ({
  childrenValues,
  groupId,
  label,
  name,
  subLabel,
}) => {
  return (
    <Field name={name}>
      {({ field, form }) => {
        const areAllChildrenSelected =
          Array.isArray(field.value) &&
          childrenValues.every((value) => field.value.includes(value));
        const inputId = `${name}-${groupId}`;

        return (
          <CheckBoxStyle className={'mainContainer'}>
            <div>
              <Label className={'radio-btn genderClass status-group-parent'}>
                <input
                  type="checkbox"
                  checked={areAllChildrenSelected}
                  onChange={() => {
                    const shouldSelectAll = !areAllChildrenSelected;
                    const nextValue = shouldSelectAll
                      ? field.value.concat(
                          childrenValues.filter(
                            (value) => !field.value.includes(value)
                          )
                        )
                      : field.value.filter(
                          (value) => !childrenValues.includes(value)
                        );

                    form.setFieldValue(name, nextValue);
                  }}
                  id={inputId}
                />
                <div className={'check'}>
                  <div className={'inside'} />
                </div>
                <Label className={' padding-correction'} for={inputId}>
                  <span
                    className={'status-group-label'}
                    style={{ display: 'none' }}
                  >
                    {label}
                  </span>
                  {subLabel ? (
                    <span className={'status-group-sublabel'}>{subLabel}</span>
                  ) : null}
                </Label>
              </Label>
            </div>
          </CheckBoxStyle>
        );
      }}
    </Field>
  );
};

StatusGroupParentCheckbox.propTypes = {
  childrenValues: PropTypes.array.isRequired,
  groupId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
};

export const getGroupedStatuses = (list) => {
  const statusesByInternalValue = new Map(
    (list || []).map((item) => [item.InternalValue, item])
  );

  return statusGroups
    .map((group) => ({
      ...group,
      items: group.values
        .map((value) => statusesByInternalValue.get(value))
        .filter(Boolean),
    }))
    .filter((group) => group.items.length > 0);
};

export const StatusCheckboxGroup = ({ group, name }) => (
  <div className={'status-group'}>
    <StatusGroupParentCheckbox
      childrenValues={group.items.map((item) => item.InternalValue)}
      groupId={group.id}
      label={group.label}
      name={name}
      subLabel={group.subLabel}
    />
    <div className={'status-group-children'}>
      {group.items.map((item) => (
        <Checkbox
          key={item.InternalValue}
          id={item.InternalValue}
          value={item.InternalValue}
          name={name}
          displayvalue={item.DisplayValue}
        />
      ))}
    </div>
  </div>
);

StatusCheckboxGroup.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
  }).isRequired,
  name: PropTypes.string.isRequired,
};

export const StatusCheckboxSet = ({ list, name }) => {
  const groupedStatuses = getGroupedStatuses(list);

  return groupedStatuses.map((group) => (
    <StatusCheckboxGroup group={group} key={group.id} name={name} />
  ));
};

StatusCheckboxSet.propTypes = {
  list: PropTypes.array,
  name: PropTypes.string.isRequired,
};
